/* eslint-disable react/prop-types */
import React from "react";
import { Button } from "@/components/ui/Button";
import { Printer } from "lucide-react";

export const SalesMetricsDisplay = ({ metrics, printers, onPrintReport }) => {
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 gap-4">
        <div className="bg-white p-4 rounded-lg border border-orange-200">
          <div className="text-sm text-gray-500">Ventas en Efectivo</div>
          <div className="text-2xl font-bold text-orange-600">
            ${metrics.cashSales.toFixed(2)}
          </div>
        </div>
        <div className="bg-white p-4 rounded-lg border border-orange-200">
          <div className="text-sm text-gray-500">Ventas con Tarjeta</div>
          <div className="text-2xl font-bold text-orange-600">
            ${metrics.cardSales.toFixed(2)}
          </div>
        </div>
      </div>

      <div className="bg-orange-100 p-4 rounded-lg border border-orange-200">
        <div className="text-sm text-gray-600">Total General</div>
        <div className="text-3xl font-bold text-orange-600">
          ${metrics.totalSales.toFixed(2)}
        </div>
        <div className="mt-2 text-sm text-gray-500">
          Total de órdenes: {metrics.totalOrders}
          <br />
          Ticket promedio: ${metrics.averageTicket.toFixed(2)}
        </div>
      </div>

      <div className="pt-4 space-y-2">
        {printers.map((printer) => (
          <Button
            key={printer.id}
            onClick={() => onPrintReport(printer.id)}
            className="w-full bg-orange-500 hover:bg-orange-600 text-white"
          >
            <Printer className="mr-2 h-4 w-4" />
            Imprimir en {printer.name}
          </Button>
        ))}
      </div>
    </div>
  );
};
